type IdentifyTrait = {
    user_uuid?: string | null;
};

/**
 * @deprecated
 * This now happens "automatically" via UserProvider on page load.
 * Please avoid direct usage aside from a handful of exceptions:
 * i.e post session mutation
 */
export const identifyUser = (
    window?: Partial<Window>,
    user_uuid?: string | null
) => {
    if (typeof window === 'undefined' || !window.analytics) {
        return;
    }

    const identifyTrait: IdentifyTrait = {
        user_uuid
    };

    if (user_uuid) {
        window.analytics.identify(user_uuid, identifyTrait);
    }
};
